/** Copies text to the clipboard. Falls back to a hidden textarea where the Clipboard API is blocked. */
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    const ta = document.createElement('textarea')
    ta.value = text
    ta.setAttribute('readonly', '')
    ta.style.position = 'fixed'
    ta.style.opacity = '0'
    document.body.appendChild(ta)
    ta.select()
    // The legacy fallback for browsers or frames without clipboard permission.
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    const ok = document.execCommand('copy')
    ta.remove()
    return ok
  }
}
